var e={"Personal information":"個人信息",Signature:"個性簽名",Gender:"性別",Male:"男",Female:"女",AllowType:"加好友驗證方式",NeedConfirm:"需要驗證",AllowAny:"同意任何用戶加好友",DenyAny:"拒絕任何用戶加「好友」",Birthday:"生日",Unknown:"未設置"};export{e as default};
